import qs from "qs";
export const wxConfig = {
  mounted() {
    this.wxConfig(); //配置微信jssdk
  },
  methods: {
    wxConfig() {
      const that = this;
      const account_id = this.$route.query.account_id;
      const data = qs.stringify({
        account_id,
        url: location.href.split("#")[0] //向服务端提供授权url参数，并且不需要#后面的部分
      });
      this.axios({
        method: "POST",
        url: "/crm/index/getSignature",
        data
      })
        .then(res => {
          if (res.data.code == 1) {
            const d = res.data.data;
            this.$wx.config({
              beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
              debug: false, // 开启调试模式,
              appId: d.appid, // 必填，企业号的唯一标识，此处填写企业号corpid
              timestamp: d.timestamp, // 必填，生成签名的时间戳
              nonceStr: d.nonceStr, // 必填，生成签名的随机串
              signature: d.signature, // 必填，签名，见附录1
              jsApiList: [
                "agentConfig", "openEnterpriseChat", "selectExternalContact", "getContext", "sendChatMessage"
              ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
      //通过ready接口处理成功验证
      that.$wx.ready(function () {
        // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
        that.axios({
          method: "POST",
          url: "/crm/index/getSignature1",
          data
        })
          .then(res => {
            if (res.data.code == 1) {
              const d = res.data.data;
              that.$wx.agentConfig({
                corpid: d.appid, // 必填，企业微信的corpid，必须与当前登录的企业一致
                agentid: d.agent_id, // 必填，企业微信的应用id （e.g. 1000247）
                timestamp: d.timestamp, // 必填，生成签名的时间戳
                nonceStr: d.nonceStr, // 必填，生成签名的随机串
                signature: d.signature, // 必填，签名，见附录-JS-SDK使用权限签名算法
                jsApiList: ["openEnterpriseChat", "selectExternalContact", "getContext", "sendChatMessage", "setClipboardData"], //必填
                success: function (res) {
                  console.log(res, "agentConfig成功回调");
                  // 回调
                },
                fail: function (res) {
                  console.log(res, "agentConfig失败回调");
                  if (res.errMsg.indexOf("function not exist") > -1) {
                    alert("版本过低请升级");
                  }
                }
              });
            }
          })
          .catch(error => {
            console.log(error);
          });
      });

      this.$wx.error(function (res) {
        console.log(res);
        //config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
      });
      this.$wx.checkJsApi({
        jsApiList: ["openEnterpriseChat", "selectExternalContact", "setClipboardData"], // 需要检测的JS接口列表，所有JS接口列表见附录2,
        success: function (res) {
          console.log("checkJsApi", res);
          // 以键值对的形式返回，可用的api值true，不可用为false
          // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
        }
      });
    },
  },
}